import { ListItem, ListItemButton, ListItemText, Stack } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import {
  formatTypePropertyWithMetadata,
  isExperimentHalting
} from 'components/alfi/alfi-utils'
import { HaltButton } from 'components/navigation/Notifications/NotificationsList/HaltButton'
import { NOTIFICATION_LEFT_PADDING } from 'components/navigation/Notifications/utils'
import useAuth from 'hooks/use-auth'
import {
  ApplicationAttackScopeItem,
  ApplicationExperiment
} from 'types/api/experiments/active'

export const ActiveApplicationAttackListItem: React.FC<{
  attack: ApplicationExperiment
  doFetch(): void
  metadata: {
    applicationQuery: Record<string, any>[]
    trafficQuery: Record<string, any>[]
  }
  onConfirmHalt(options: Record<string, any>): void
}> = ({ attack, doFetch, metadata, onConfirmHalt, ...rest }) => {
  const { guid: attackId, application_scope, traffic, service_states } = attack
  const { applicationQuery, trafficQuery } = metadata
  const appScope = application_scope[0] ?? ({} as ApplicationAttackScopeItem)
  const applicationName = appScope?.fields?.name
  const { query } = traffic[0]
  const isHalting = isExperimentHalting(service_states)
  const { currentTeamId } = useAuth()

  const handleHaltRequest = () =>
    onConfirmHalt({
      type: 'alfi',
      attack,
      currentTeamId,
      reason: '',
      runNumber: null
    })

  const description = `${formatTypePropertyWithMetadata(
    appScope,
    applicationQuery
  )}, ${formatTypePropertyWithMetadata(query, trafficQuery)}`

  return (
    <ListItem
      data-test-notification-item
      disablePadding
      component="div"
      secondaryAction={
        <HaltButton
          fetchAttack={doFetch}
          isHalting={isHalting}
          showHaltReason={false}
          trackingOptions={{ AttackId: attackId }}
          onConfirmRequest={handleHaltRequest}
        />
      }
      {...rest}
    >
      <ListItemButton component={Link} to={`/attacks/application/${attackId}`}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          sx={{ pl: NOTIFICATION_LEFT_PADDING, width: '100%' }}
        >
          <ListItemText
            data-test-notification-text
            primary={`Application: ${applicationName}`}
            secondary={description}
          />
        </Stack>
      </ListItemButton>
    </ListItem>
  )
}
